// Mutable shared scroll state, read every frame inside the R3F render loop
// without triggering React re-renders.
export const scrollState = {
  progress: 0,
  activeSectionIndex: 0,
};
